import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import JusInput from 'component/newInput.component';
import Button from 'component/button.component';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import SocialAccess from '../social/';
import { USER_LOGIN_ERROR, USER_LOGIN_SUCCESS } from 'config/constants';
import ResetPasswordModal from 'component/_structure/site/header/reset.password.modal.component';
import { userLogin } from 'store/action/user.action';

const useStyles = makeStyles(theme => ({
  margin: {
    margin: theme.spacing(1),
  },
}));

export default function Login(props) {
  const classes = useStyles();
  const [controlValues, setValues] = useState({
    email: '',
    emailError: false,
    password: '',
    passwordError: false,
  });
  const resetPassword = props;

  const _userLogin = user => {
    userLogin(user)
      .then(({ type, message }) => {
        if (type === USER_LOGIN_SUCCESS) {
          window.location.href = '/';
        } else if (type === USER_LOGIN_ERROR) {
          toast.error(message);
        }
      })
      .catch(err => {
        console.error('Por favor, entre em contato com o suporte.');
        toast.error('Usuário e/ou senha incorretos!');
      }).finally(() => {
        props.setLoading(false);
      });
  };

  const onValueChange = (value, prop) => {
    setValues({
      ...controlValues,
      [prop]: value,
    });
  };

  const _keyDown = e => {
    if (e.key === 'Enter') {
      submitForm(e);
    }
  };

  const validateForm = () => {
    let isOk = true;

    if (controlValues.email.length <= 0) {
      setValues(prevState => ({
        ...prevState,
        emailError: true,
      }));
      isOk = false;
    }

    if (controlValues.password.length <= 0) {
      setValues(prevState => ({
        ...prevState,
        passwordError: true,
      }));
      isOk = false;
    }

    return isOk;
  };

  const submitForm = e => {
    props.setLoading(true);
    if (validateForm()) {
      _userLogin({
        type: 'DEFAULT',
        login: controlValues.email,
        password: controlValues.password,
      });
    } else {
      toast.error('Não foi possível realizar o login. Tente novamente!');
    }
  };

  return (
    <div className="container flex-column align-stretch">
      <Helmet>
        <title>Acessar o Juslabore</title>
        <meta
          name="description"
          content="Cadastra-se agora, gratuitamente. E faça parte da nossa comunidade de conhecimento"
        />
      </Helmet>

      <h3 className="self-align-center" style={{ marginBottom: 20 }}>
        <b>Acessar Conta</b>
      </h3>

      <SocialAccess />

      <form
        onSubmit={e => submitForm(e)}
        onKeyDown={e => _keyDown(e)}
        style={{ textAlign: '-webkit-center' }}
      >
        <div className={classes.margin}>
          <JusInput
            IconComponent={MailOutlineIcon}
            label={'Informe seu email'}
            isRequired={true}
            setValue={onValueChange}
            property={'email'}
            setError={controlValues.emailError}
          />

          <JusInput
            IconComponent={VpnKeyIcon}
            label={'Informe sua senha'}
            isPassword={true}
            setValue={onValueChange}
            property={'password'}
            setError={controlValues.passwordError}
          />
        </div>
        <ResetPasswordModal resetPassword={resetPassword} />
        <Button
          className="align-center justify-center"
          onClick={e => submitForm(e)}
          text="ENTRAR"
          style={{
            backgroundColor: '#185335',
            marginTop: 80,
            width: 200,
            alignSelf: 'center',
          }}
        />
      </form>
    </div>
  );
}
